import * as bcrypt from 'bcrypt';
import { PasswordData } from '@ip6m/types';
import { UserRepositoryService } from '../../database/repositories/user-repository.service';
import { BCRYPT_SALT_ROUNDS } from '@ip6m/server/config';
import { Inject, Injectable } from '@nestjs/common';

@Injectable()
export class PublicUserService {

    constructor(
        private userRepo: UserRepositoryService,
        @Inject(BCRYPT_SALT_ROUNDS) private bcryptSaltRounds: number
    ) {}
    
    async getUsers() {
        const entities = await this.userRepo.getUsers();
        entities.forEach(user => {
            delete user.password;
        })

        return entities;        
    }

    async setPassword(data: PasswordData) {
        const hash = await bcrypt.hash(
            data.password,
            this.bcryptSaltRounds
        );
        await this.userRepo.setPassword(data.uid, hash);
        return true;        
    }
}
